import React from "react";
import { Divider, Typography } from "antd";

const { Title, Text } = Typography;

const SectionHeader = ({
  title,
  description,
  description2,
  action, // Accepts JSX for custom action/button
  className = "",
  addDivider = false,
}) => {
  return (
    <>
      <div className={`flex items-center justify-between ${className}`}>
        <div className="mr-4">
          <Title level={4} className="!mb-0">
            {title}
          </Title>
          {description && <Text className="!text-black-65">{description}</Text>}
          {description2 && <Text className="block !text-black-65">{description2}</Text>}
        </div>
        {action}
      </div>
      {addDivider && <Divider className="!my-6" />}
    </>
  );
};

export default SectionHeader;
